import React from 'react'
import OALogo from './OALogo'
import { useTranslation } from 'react-i18next'
import {useConfig} from '../ConfigProvider';

export default function Footer() {
  const config = useConfig()

  return (
    <div className='w-full bg-black text-white py-6 flex flex-col items-center gap-2'>
      <OALogo  variant='white'/>
      <p>{new Date().getFullYear()} © ON AIR Fitness</p>
      <div className='flex gap-3'>
        <a href={config.cgvUrl} target="_blank">CGV</a>
        <a href="javascript:Didomi.preferences.show()">COOKIES</a>
      </div>
      <div style={{display:'flex', justifyContent:'center', gap:'2rem'}}>
        {config.footerLogos.map( url => {
          return <img key={url} width='40' height='auto' src={url} />  
        })}
      </div>
    </div>
  )
}